import BoxUrlOrFile from "@components/BoxUrlOrFile";
import ButtonContainer from "@components/ButtonContainer";
import Select from "@components/EasyDev/form/Select";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextField from "@components/Shared/FormTextField";
import { GalleryType } from "@enums/galleryType";
import { galleryTypeOptions } from "@helpers/createMedia.helper";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field, useFormState } from "react-final-form";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => {
  const { values } = useFormState();

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">Media</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            component={FormTextField}
            type="text"
            placeholder={"Enter a Title"}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <Field
            name="date"
            component={FormDatePickerField}
            placeholder="Enter a Date"
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">Type</span>
        <div className="form__form-group-field">
          <Field
            name="type"
            component={Select}
            isAboveError
            placeholder="Enter Gallery Type"
            options={galleryTypeOptions}
          />
        </div>
      </div>

      {values?.type?.value === GalleryType.Single ? (
        <BoxUrlOrFile title="Gallery" formFieldName="gallery" />
      ) : (
        <FileUpload
          title="Gallery"
          isSingle={values?.type?.value === GalleryType.Single}
        />
      )}

      <ButtonContainer />
    </form>
  );
};

export default CreateForm;
